import React from 'react';
import informationIcon from '../../../assets/images/Information.svg';
import type { InstructionsInfoItem as InfoItem } from '@app-types/instructions';
import './InstructionsInfoItem.less';

export interface InstructionsInfoItemProps {
  data: InfoItem;
  isOpeningReport?: boolean;
  onOpenReport?: (item: InfoItem) => Promise<string>;
}

/**
 * Single disclosure row (title + time + category badge).
 * Figma: desktop 3176:9092, mobile 3372:22973 (same shape, wraps on mobile).
 */
const InstructionsInfoItem: React.FC<InstructionsInfoItemProps> = ({
  data,
  isOpeningReport = false,
  onOpenReport,
}) => {
  const hasReportContext = Boolean(data.pnac && data.createdAt);
  const canOpenReport = Boolean(onOpenReport && hasReportContext && !isOpeningReport);

  const handleReportClick = async () => {
    if (!onOpenReport || !canOpenReport) return;

    const reportWindow = window.open('', '_blank');
    if (reportWindow) reportWindow.opener = null;

    try {
      const reportUrl = await onOpenReport(data);
      if (reportWindow) {
        reportWindow.location.href = reportUrl;
      } else {
        window.open(reportUrl, '_blank', 'noopener,noreferrer');
      }
    } catch {
      reportWindow?.close();
    }
  };

  return (
    <article className="instructions-info-item" data-node-id={data.nodeId}>
      {onOpenReport ? (
        <button
          type="button"
          className="instructions-info-item__title instructions-info-item__title-button"
          aria-label={`${data.title}のレポートを開く`}
          disabled={!canOpenReport}
          onClick={handleReportClick}
        >
          {data.title}
        </button>
      ) : (
        <p className="instructions-info-item__title">{data.title}</p>
      )}
      <div className="instructions-info-item__meta">
        <span className="instructions-info-item__time">
          <img
            className="instructions-info-item__time-icon"
            src={informationIcon}
            alt=""
            aria-hidden="true"
          />
          <span className="instructions-info-item__time-text">{data.time}</span>
        </span>
        <span className="instructions-info-item__badge">{data.category}</span>
      </div>
    </article>
  );
};

export default InstructionsInfoItem;
